<script>
import Layout from "../../../layouts/manage";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
// import Button from "@/components/button";
import Input from "@/components/c-input";
import Area from "@/components/c-input-area";
// import Dropzone from "@/components/c-dropzone";
import Select from "@/components/c-select";
// import List from "../../../../components/list";
import { customerService } from "../../../../services/contactservice/customer.service";
import { propertyService } from "../../../../services/propertyservice/property.service";

// import i18n from "../../../../i18n";
import Loading from "@/components/c-loading";

/**
 * Contacts-list component  
 */
export default {
  page: {
    title: "Property Form",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loading, 
    // Button,
    Input,
    Area,
    // Dropzone,
    Select,
    // List
  },
  data() {
    return {
      isAdd: true,
      fetchingStats: false,
      tryingToSubmit: false,
      title: "property",
      currency: "",
      selectCustomer: null,
      propertyData: null,
      customerData: {},
      projectData: {},
      floorData: {},
      statusData: {},
      typeData: {},
      groupData: {},
      currencyData: {},
      breadCrumb: {},
      attachement: {},
      handOverData: {},



      dataCode: '',
      dataType: 0,
      dataCustomer: 0,
      dataDescription: '',
      dataNetSize: 0,
      dataGrossSize: 0,
      dataFloor: 0,
      dataProject: 0,
      dataGroup: 0,
      dataStatus: 0,
      dataCurrency: 0,
      dataPrice: 0,
      dataPhoto: [],
      dataLivingRoomNo: 0,
      dataBedRoomNo: 0,
      dataKitchenNo: 0,
      dataBathRoomNo: 0,
      dataBalconyNo: 0,

    };
      
  },
  mounted() {
    /* eslint-disable no-console */
   
    // this.loadingCommissionData();
    // this.loadingCancelationData();
    // this.loadingTransferData();
    // this.loadingTypeData();
    // this.loadingStatusData();
    // this.loadingProjectData();
    // this.loadingFloorData();
    // this.loadingCurrencyData();
    // this.loadingGroupData();
    // this.loadingCustomerData();
    // this.loadingCommissionData();
    // this.loadingCancelationData();
    // this.loadingTransferData();
  

    this.dataType = 1;
    this.dataStatus = 1;
    this.dataCurrency = 1;

    let hasId = 'id' in this.$route.params;
    this.isAdd = this.fetchingStats = !hasId;
    if(hasId) {
      this.loadingData(this.$route.params.id);     

    }else{
      // Loading
          this.loadingTypeData();
          this.loadingStatusData();
          this.loadingProjectData();
          this.loadingFloorData();
          this.loadingCurrencyData();
          this.loadingGroupData();
          this.loadingCustomerData();
          this.loadingFloorData();
    }
  },

  methods: {
    loadingData: function(id) {
      // console.log("AAAAAA", id);
      this.fetchingStats = false;
      propertyService.getOne(id)
        .then(response => {
          // console.log(response);

          if(response.data == null) {
            this.$router.push(this.$route.query.redirectFrom || {
              name: "property-add"
            });
          }



          this.breadCrumb = {
            text: response.data.code,
            active: true,
          };

          this.fetchingStats = true;
          this.propertyData = response;

          this.dataCustomer = this.propertyData.data.customer_id;

          this.dataCode = this.propertyData.data.code;
          this.dataType = this.propertyData.data.property_type_id;
          this.dataDescription = this.propertyData.data.description;

          this.dataNetSize = this.propertyData.data.net_size;
          this.dataGrossSize = this.propertyData.data.cross_size;
          this.dataFloor = this.propertyData.data.project_floor_id;
          this.dataProject = this.propertyData.data.project_id;
          this.dataGroup = this.propertyData.data.property_group_id;
          this.dataStatus = this.propertyData.data.property_status_id;
          this.dataCurrency = this.propertyData.data.currency_id;
          this.dataPrice = this.propertyData.data.price;

          this.dataLivingRoomNo = this.propertyData.data.living_room_no;
          this.dataBedRoomNo = this.propertyData.data.bed_room_no;
          this.dataKitchenNo = this.propertyData.data.kitchen_no;
          this.dataBathRoomNo = this.propertyData.data.bathroom_no;
          this.dataBalconyNo = this.propertyData.data.balcony_no;
          
        

          // Loading
          // this.loadingTypeData();
          // this.loadingStatusData();
          // this.loadingProjectData();
          // this.loadingFloorData();
          // this.loadingCurrencyData();
          // this.loadingGroupData();
          // this.loadingFloorData();
          this.loadingCustomerById(this.propertyData.data.customer_id);
         
        });

    },

    loadingCustomerById: function(id) {
      customerService.getOne(id)
        .then(response => {
          // console.log(JSON.stringify(response.data));
          this.selectCustomer = response.data;
           this.loadingPropertyAttachmentByPropertyId(this.propertyData.data.id);
        });
    },
    loadingHandOverById: function(id) {
      customerService.getOne(id)
        .then(response => {
          // console.log(JSON.stringify(response.data));
          this.selectCustomer = response.data;
           this.loadingPropertyAttachmentByPropertyId(this.propertyData.data.id);
        });
    }
  }
};
</script>

<template>
  <Layout>
    <div v-if="this.isAdd">
      <PageHeader :items="[{
        text: $t('property.list'),
        href: '/general/property',
      }, {
        text: $t('property.new'),
        active: true
      }]" :title="this.isAdd ? $t('property.new') : $t('property.edit')" />
    </div>
    <div v-else>
      <PageHeader :items="[{
        text: $t('property.list'),
        href: '/general/property',
      }, this.breadCrumb]" :title="this.isAdd ? $t('property.new') : $t('property.edit')" />
    </div>
    <Loading :loaded="fetchingStats" />

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <b-tabs content-class="p-3 text-muted">
              <b-tab active class="border-0" style="background: #fff">
                <template v-slot:title>
                  <div class="btn-block">
                    <i class="bx bx-cart bx-tada font-size-20 align-middle me-2"></i>
                    {{$t('customer.general')}}
                  </div>
                </template>
                <div v-show="fetchingStats" class="row">
                  <b-form class="row">
                    <div class="col-lg-8">
                      <div class="card">
                        <div class="card-body">
                          <div class="row">
                            <div class="col-md-6">
                              <Input 
                                :type="'text'"
                                :id="'code'"
                                v-model="dataCode"
                                :label="'customer.code'" 
                                :require="true"
                              /> 
                            </div>
                            <div class="col-md-6">
                               <Input 
                                :type="'text'"
                                :id="'code'"
                                v-model="propertyData.data.project"
                                :label="'property.project'" 
                              /> 
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                               <Input 
                                :type="'text'"
                                :id="'code'"
                                v-model="propertyData.data.floor"
                                :label="'property.floor'" 
                              /> 
                            </div>
                            <div class="col-md-6">
                               <Input 
                                :type="'text'"
                                :id="'code'"
                                v-model="propertyData.data.group"
                                :label="'property.group'" 
                              /> 
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                            
                               <Input 
                                :type="'text'"
                                :id="'code'"
                                v-model="propertyData.data.type"
                                :label="'property.type'" 
                              /> 
                            </div>
                            <div class="col-md-6">
                               <Input 
                                :type="'text'"
                                :id="'code'"
                                v-model="propertyData.data.status"
                                :label="'property.status'" 
                              /> 
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <Input 
                                :type="'number'"
                                :id="'price'"
                                v-model="dataPrice"
                                :last="currency"
                                :label="'property.price'" 
                                :require="true"
                              />
                            </div>
                            <div class="col-md-6">
                              <Select 
                                :text="'name'"
                                @change="currencyChanged" 
                                :id="'currency_id'"
                                :class="'d-none'"
                                v-model="dataCurrency"
                                :list="this.currencyData"
                                :label="'property.currency'"
                                :disabled="true"
                              />
                               <Input 
                                :type="'text'"
                                :id="'code'"
                                v-model="propertyData.data.currency"
                                :label="'property.currency'" 
                              /> 
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <Input 
                                :type="'number'"
                                :id="'cross_size'"
                                :last="'general.square'"
                                v-model="dataGrossSize"
                                :label="'property.gross-size'" 
                              />
                            </div>
                            <div class="col-md-6">
                              <Input 
                                :type="'number'"
                                :last="'general.square'"
                                :id="'net_size'"
                                v-model="dataNetSize"
                                :label="'property.net-size'" 
                              />
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-3">
                              <Input 
                                :type="'number'"
                                :id="'bed_room_no'"
                                v-model="dataBedRoomNo"
                                :label="'property.bed-room-no'" 
                              />
                            </div>
                            <div class="col-md-3">
                              <Input 
                                :type="'number'"
                                :id="'living_room_no'"
                                v-model="dataLivingRoomNo"
                                :label="'property.living-room-no'" 
                              />
                            </div>

                            <div class="col-md-2">
                              <Input 
                                :type="'number'"
                                :id="'kitchen_no'"
                                v-model="dataKitchenNo"
                                :label="'property.kitchen-no'" 
                              />
                            </div>
                            <div class="col-md-2">
                              <Input 
                                :type="'number'"
                                :id="'bathroom_no'"
                                v-model="dataBathRoomNo"
                                :label="'property.bathroom-no'" 
                              />
                            </div>
                            <div class="col-md-2">
                              <Input 
                                :type="'number'"
                                :id="'balcony_no'"
                                v-model="dataBalconyNo"
                                :label="'property.balcony-no'" 
                              />
                            </div>

                          </div>

                          <div class="row">
                            <div class="col-lg-12">
                              <Area 
                                :rows="7"
                                :id="'description'"
                                v-model="dataDescription"
                                :label="'property.description'"  />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-4">
                      
                      <div v-if="this.selectCustomer" class="card">
                        <div class="card-body">
                          <div class="row">
                            <div class="col-md-12">
                              <div class="row">
                                <div class="col-md-8">
                                  <h4 class="card-title mb-4">{{$t('customer.text')}}</h4>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-12">
                              <div class="row">
                                <div class="col-md-4 mb-3">{{this.$t('customer.name')}}</div>
                                <div class="col-md-8 mb-3">: <b>{{this.selectCustomer == null ? '' : this.selectCustomer.name}}</b></div>
                              </div>
                              <div class="row">
                                <div class="col-md-4 mb-3">{{this.$t('customer.name-en')}}</div>
                                <div class="col-md-8 mb-3">: <b>{{this.selectCustomer == null ? '' : this.selectCustomer.name_en}}</b></div>
                              </div>
                              <div class="row">
                                <div class="col-md-4 mb-3">{{this.$t('customer.id-type')}}</div>
                                <div class="col-md-8 mb-3">: <b>{{this.selectCustomer == null ? '' : this.selectCustomer.idType}}</b></div>
                              </div>
                              <div class="row">
                                <div class="col-md-4 mb-3">{{this.$t('customer.number')}}</div>
                                <div class="col-md-8 mb-3">: <b>{{this.selectCustomer == null ? '' : this.selectCustomer.id_no}}</b></div>
                              </div>
                              <div class="row">
                                <div class="col-md-4 mb-3">{{this.selectCustomer && this.selectCustomer.phone_no_2 ? this.$t('customer.phone-no-1') : this.$t('customer.phone-no')}}</div>
                                <div class="col-md-8 mb-3">: <b>{{this.selectCustomer == null ? '' : this.selectCustomer.phone_no_1}}</b></div>
                              </div>
                              <div class="row" v-show="this.selectCustomer != null && this.selectCustomer.phone_no_2">
                                <div class="col-md-4 mb-3">{{this.$t('customer.phone-no-2')}}</div>
                                <div class="col-md-8 mb-3">: <b>{{this.selectCustomer == null ? '' : this.selectCustomer.phone_no_2}}</b></div>
                              </div>
                              <div class="row">
                                <div class="col-md-4 mb-3">{{this.$t('customer.email')}}</div>
                                <div class="col-md-8 mb-3">: <b>{{this.selectCustomer == null ? '' : this.selectCustomer.email}}</b></div>
                              </div>
                              <div v-show="this.selectCustomer && (this.selectCustomer.partner_name && this.selectCustomer.partner_have_to)">
                                <div class="card-title mb-3"></div>
                                <h4 class="card-title mb-3">{{$t('customer.partner-info')}}</h4>
                                <div class="row">
                                  <div class="col-md-4 mb-3">{{this.$t('customer.name')}}</div>
                                  <div class="col-md-8 mb-3">: <b>{{this.selectCustomer == null ? '' : this.selectCustomer.partner_name}}</b></div>
                                </div>
                                <div class="row">
                                  <div class="col-md-4 mb-3">{{this.$t('customer.partner-type')}}</div>
                                  <div class="col-md-8 mb-3">: <b>{{this.selectCustomer == null ? '' : this.selectCustomer.partner_have_to}}</b></div>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>

                      <div v-if="this.handOverData" class="card">
                        <div class="card-body">
                          <div class="row">
                            <div class="col-md-12">
                              <div class="row">
                                <div class="col-md-8">
                                  <h4 class="card-title mb-4">{{$t('manage.keyover.new')}}</h4>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-12">
                              <div class="row">
                                <div class="col-md-4 mb-3">{{this.$t('customer.name')}}</div>
                                <div class="col-md-8 mb-3">: <b>{{this.selectCustomer == null ? '' : this.selectCustomer.name}}</b></div>
                              </div>
                              <div class="row">
                                <div class="col-md-4 mb-3">{{this.$t('customer.name-en')}}</div>
                                <div class="col-md-8 mb-3">: <b>{{this.selectCustomer == null ? '' : this.selectCustomer.name_en}}</b></div>
                              </div>
                              <div class="row">
                                <div class="col-md-4 mb-3">{{this.$t('customer.id-type')}}</div>
                                <div class="col-md-8 mb-3">: <b>{{this.selectCustomer == null ? '' : this.selectCustomer.idType}}</b></div>
                              </div>
                              <div class="row">
                                <div class="col-md-4 mb-3">{{this.$t('customer.number')}}</div>
                                <div class="col-md-8 mb-3">: <b>{{this.selectCustomer == null ? '' : this.selectCustomer.id_no}}</b></div>
                              </div>
                              <div class="row">
                                <div class="col-md-4 mb-3">{{this.selectCustomer && this.selectCustomer.phone_no_2 ? this.$t('customer.phone-no-1') : this.$t('customer.phone-no')}}</div>
                                <div class="col-md-8 mb-3">: <b>{{this.selectCustomer == null ? '' : this.selectCustomer.phone_no_1}}</b></div>
                              </div>
                              <div class="row" v-show="this.selectCustomer != null && this.selectCustomer.phone_no_2">
                                <div class="col-md-4 mb-3">{{this.$t('customer.phone-no-2')}}</div>
                                <div class="col-md-8 mb-3">: <b>{{this.selectCustomer == null ? '' : this.selectCustomer.phone_no_2}}</b></div>
                              </div>
                              <div class="row">
                                <div class="col-md-4 mb-3">{{this.$t('customer.email')}}</div>
                                <div class="col-md-8 mb-3">: <b>{{this.selectCustomer == null ? '' : this.selectCustomer.email}}</b></div>
                              </div>
                              <div v-show="this.selectCustomer && (this.selectCustomer.partner_name && this.selectCustomer.partner_have_to)">
                                <div class="card-title mb-3"></div>
                                <h4 class="card-title mb-3">{{$t('customer.partner-info')}}</h4>
                                <div class="row">
                                  <div class="col-md-4 mb-3">{{this.$t('customer.name')}}</div>
                                  <div class="col-md-8 mb-3">: <b>{{this.selectCustomer == null ? '' : this.selectCustomer.partner_name}}</b></div>
                                </div>
                                <div class="row">
                                  <div class="col-md-4 mb-3">{{this.$t('customer.partner-type')}}</div>
                                  <div class="col-md-8 mb-3">: <b>{{this.selectCustomer == null ? '' : this.selectCustomer.partner_have_to}}</b></div>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </b-form>
                </div>    
              </b-tab>
           
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>